var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-5"},[_c('iframe',{attrs:{"width":_vm.sizeW,"height":_vm.sizeH,"src":`https://www.youtube.com/embed/${_vm.videoHash}`,"allow":"accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }